import axios from 'axios';

/**
 * 获取报告配置
 */
export const getReportConfig = (params) => {
  return axios.get(`/api/reportConfig/${params.deviceId}`);
};

export const updateReportCaptions = (params) => {
  const { deviceId, payload } = params;
  return axios.post(`/api/reportConfig/${deviceId}/captions`, payload);
};

export const updateReportColumns = (params) => {
  const { deviceId, payload } = params;
  return axios.post(`/api/reportConfig/${deviceId}/columns`, payload);
};
